import { StyleClass } from "./CSS";

export const pillButtonStyleClass = StyleClass(`pillButtonStyle`, {
    display: `inline-flex`,
    alignItems: `center`,
    justifyContent: `center`,
    position: `relative`,
    top: `1px`,
    padding: `4px 12px`,
    borderRadius: `999px`,
    border: `1px solid hsl(42deg 58% 56% / 0.16)`,
    background:
        `linear-gradient(180deg, hsl(38deg 28% 18% / 0.56) 0%, hsl(220deg 14% 10% / 0.34) 100%)`,
    boxShadow:
        `inset 0 1px 0 hsl(0deg 0% 100% / 0.05), 0 0 0 1px hsl(220deg 18% 6% / 0.1)`,
    color: `hsl(47deg 40% 78% / 0.92)`,
    cursor: `pointer`,
    fontFamily: `'Share Tech Mono', monospace`,
    fontSize: `11px`,
    letterSpacing: `0.08em`,
    lineHeight: 1,
    textDecoration: `none`,
    textTransform: `uppercase`,
    transition:
        `opacity 120ms ease, transform 120ms ease, box-shadow 120ms ease, color 120ms ease, border-color 120ms ease`,
    userSelect: `none`,
    opacity: 0.58,
    ":hover": {
        opacity: 1,
        transform: `translateY(-1px)`,
        color: `hsl(47deg 72% 82%)`,
        borderColor: `hsl(47deg 70% 62% / 0.3)`,
        boxShadow:
            `inset 0 1px 0 hsl(0deg 0% 100% / 0.08), 0 0 8px hsl(42deg 70% 58% / 0.08)`,
    },
    ":active": {
        transform: `translateY(0px) scale(0.98)`,
        color: `hsl(47deg 76% 86%)`,
        borderColor: `hsl(47deg 78% 68% / 0.34)`,
        boxShadow:
            `inset 0 1px 0 hsl(0deg 0% 100% / 0.06), 0 0 4px hsl(42deg 70% 58% / 0.06)`,
    },
});
